import CloseRounded from "@mui/icons-material/CloseRounded";
import { IconButton, Tooltip } from "@mui/material";
import cx from "classnames";
import {
  AI_CONTEXT_DESCRIPTIONS,
  type AiContextItem,
} from "../../../../AiToolboxSection.context";
import { AI_CONTEXT_BADGE_TYPE_COLORS } from "./AiContextBadge.constants";

export interface AiContextBadgeProps {
  item: AiContextItem;
  onRemove: () => void;
}

const AiContextBadge = ({ item, onRemove }: AiContextBadgeProps) => {
  const label = item.label ?? AI_CONTEXT_DESCRIPTIONS[item.type];

  return (
    <Tooltip
      title={
        <div className="max-w-xs">
          <div className="font-medium mb-1">{label}</div>
          <div className="text-xs opacity-80 wrap-break-word">{item.value}</div>
        </div>
      }
      arrow
      placement="top"
    >
      <div
        className={cx(
          "inline-flex items-center gap-1 pl-2 py-0.2 rounded-sm text-xs border min-w-0",
          " group transition-colors",
          AI_CONTEXT_BADGE_TYPE_COLORS[item.type]
        )}
      >
        <span className="flex-1 truncate">{item.value}</span>
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          sx={{
            padding: "2px",
            "& svg": { fontSize: "14px" },
          }}
        >
          <CloseRounded fontSize="inherit" />
        </IconButton>
      </div>
    </Tooltip>
  );
};

export default AiContextBadge;
